module.exports = __webpack_public_path__ + "img/ic-departments-inactive.7a18df7f.svg";